var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 91,
    viewBox: "0 0 121 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1959",
    "data-name": "Group 1959",
    transform: "translate(-359 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1955",
    "data-name": "Group 1955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_147899",
    "data-name": "Rectangle 147899",
    transform: "translate(359 252)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 91,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 120,
    height: 90,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_867",
    "data-name": "Line 867",
    x2: 120,
    transform: "translate(359.5 312.5)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_871",
    "data-name": "Line 871",
    x2: 120,
    transform: "translate(359.5 282.506)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_873",
    "data-name": "Line 873",
    x2: 120,
    transform: "translate(359.5 252.512)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_869",
    "data-name": "Line 869",
    x2: 120,
    transform: "translate(359.5 342.494)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3261",
    "data-name": "Path 3261",
    d: "M120,0",
    transform: "translate(359.5 282.506)",
    fill: "none",
    stroke: "#c2c4c6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "A",
    transform: "translate(415 274)",
    fill: "#575757",
    fontSize: 14,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    id: "B",
    transform: "translate(415 303)",
    fill: "#575757",
    fontSize: 14,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B")), /*#__PURE__*/React.createElement("text", {
    id: "C",
    transform: "translate(415 333)",
    fill: "#575757",
    fontSize: 14,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelector);
export default __webpack_public_path__ + "static/media/selector.abc995d8ee0fc454eb3b86900b7ed39b.svg";
export { ForwardRef as ReactComponent };